import { Component, OnInit } from '@angular/core';

// Cookie notice URL is set by the server-rendered Razor page (Index.cshtml) from C# Constants
declare var COOKIE_NOTICE_URL: string;

// Declare OneTrust global object for TypeScript
declare const OneTrust: {
  ToggleInfoDisplay: () => void;
};

@Component({
  selector: 'opm-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.less'],
  standalone: false
})
export class FooterComponent implements OnInit {
  constructor() { }

  ngOnInit() { }

  /**
   * Opens the cookie notice page in a new tab.
   */
  openCookieNotice(event: Event): void {
    event.preventDefault();
    window.open(COOKIE_NOTICE_URL, '_blank', 'noopener,noreferrer');
  }

  /**
   * Opens the OneTrust cookie preferences panel.
   * Uses OneTrust's ToggleInfoDisplay API to programmatically open the panel.
   */
  openCookieSettings(event: Event): void {
    event.preventDefault();
    
    // Use OneTrust API to open the preferences panel
    if (typeof OneTrust !== 'undefined' && OneTrust.ToggleInfoDisplay) {
      OneTrust.ToggleInfoDisplay();
    } else {
      console.warn('OneTrust SDK not loaded. Cookie settings panel cannot be opened.');
    }
  }
}
